import { cn } from '@/lib/ui-kit/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-v2-surface-secondary', className)}
      {...props}
    />
  );
}

export { Skeleton };
